import {connect} from 'react-redux';
import ReactModal from 'react-modal';
import React, {Component} from 'react';
import {withRouter} from 'react-router-dom';

import ObjectApi from '../../api/Objects';

class SendMail extends Component {
    state = {
        name: '',
        message: '',
        subject: '',
        isShowModal: false,
        recipientEmail: ''
    };

    showModal = event => {
        const {
            i18n,
            user: {
                currentUser: {
                    firstName
                }
            }
        } = this.props;
        event.preventDefault();

        this.setState({
            isShowModal: true,
            recipientEmail: '',
            name: firstName !== null ? firstName : '',
            subject: i18n['objectPage.sendMail.subjectDefault'],
            message: `${i18n['objectPage.sendMail.messageDefault']} - ${window.location.href}`
        });
    };

    handleChange = event => {
        const newState = {};
        newState[event.currentTarget.name] = event.currentTarget.value;

        this.setState(newState);
    };

    hideModal = isNeedSendMail => {
        if (isNeedSendMail) {
            const {message, subject, recipientEmail} = this.state;

            ObjectApi.emailSendRequest(message, subject, recipientEmail);
        }

        this.setState({
            isShowModal: false,
        });
    };

    render() {
        const {isShowModal, name, message, subject, recipientEmail} = this.state;
        const {i18n} = this.props;

        return (
            <span>
                <a href="" onClick={this.showModal} className="btn-border">
                    <i className="send"/>
                    <span>{i18n['objectPage.sendMail']}</span>
                </a>

                <ReactModal
                    isOpen={isShowModal}
                    className="custom-react-modal"
                    overlayClassName="custom-react-modal-overlay"
                >
                    <form className="light">
                        <label>
                            {i18n['objectPage.sendMail.toWhom']}:
                            <input
                                type="email"
                                name="recipientEmail"
                                value={recipientEmail}
                                onChange={this.handleChange}
                                placeholder={i18n['objectPage.sendMail.email.placeholder']}
                            />
                        </label>

                        <label>
                            {i18n['objectPage.sendMail.yourName']}:
                            <input
                                name="name"
                                value={name}
                                onChange={this.handleChange}
                            />
                        </label>

                        <label>
                            {i18n['objectPage.sendMail.subject']}:
                            <input
                                name="subject"
                                value={subject}
                                onChange={this.handleChange}
                            />
                        </label>

                        <label>
                            {i18n['objectPage.sendMail.message']}:
                            <textarea
                                name="message"
                                value={message}
                                onChange={this.handleChange}
                            />
                        </label>
                    </form>

                    <br/><br/>

                    <button onClick={() => this.hideModal(false)} className="btn btn-border">
                        {i18n['objectPage.callbackClose']}
                    </button>

                    <button onClick={() => this.hideModal(true)} className="btn">
                        {i18n['objectPage.sendMail.send']}
                    </button>
                </ReactModal>
            </span>
        );
    }
}

const mapStateToProps = state => ({
    user: state.user,
    i18n: state.languages.i18n
});

const mapDispatchToProps = {};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SendMail));



// WEBPACK FOOTER //
// ./src/components/PropertyPage/SendMail.js